import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { i18n } from 'constant/String';
import CompanyInfoForm from './CompanyInfoForm';
import { isUserCompanySelector } from 'redux/slices/signUp/signUpSlice';

const CompanyInfo = ({ onNext, onPrev, usingFromRegister }) => {
  const isUserCompany = useSelector(isUserCompanySelector);

  const companySchema = yup
    .object({
      companyName: yup.string().required(i18n.errors.required),
      telephoneAreaCode: yup.string().required(i18n.errors.required),
      telephoneCountryCode: yup.string().required(i18n.errors.required),
      mobileCountryCode: yup.string().required(i18n.errors.required),
      telephone: yup.string().required(i18n.errors.required),
      mobile: yup.string(),
      taxOffice: yup.string().required(i18n.errors.required).nullable(),
      taxNumber: yup.string().required(i18n.errors.required).nullable(),
    })
    .required(i18n.errors.required);

  const individualSchema = yup
    .object({
      companyName: yup.string().required(i18n.errors.required),
      telephoneCountryCode: yup.string().required(i18n.errors.required),
      telephoneAreaCode: yup.string().required(i18n.errors.required),
      mobileCountryCode: yup.string().required(i18n.errors.required),
      telephone: yup.string().required(i18n.errors.required),
      mobile: yup.string(),
    })
    .required(i18n.errors.required);

  const methods = useForm({
    resolver: yupResolver(isUserCompany ? companySchema : individualSchema),
  });

  const onSubmit = () => {
    onNext();
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col w-full gap-y-4 md:mt-10 items-center justify-center h-full"
      >
        <CompanyInfoForm
          onNext={onSubmit}
          usingFromRegister={usingFromRegister}
          onPrev={onPrev}
        />
      </form>
    </FormProvider>
  );
};

CompanyInfo.propTypes = {
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  usingFromRegister: PropTypes.bool,
};

export default CompanyInfo;
